import React, { useRef, createContext, useCallback, useState } from "react";

const AppContext = createContext();

export function AppProvider({ children }) {
  

  return (
    <AppContext.Provider
      value={{
        
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export default AppContext;
